/**
 * Utilitários para manipulação de estruturas de formulário
 */

/**
 * Atualiza campos em uma estrutura de formulário baseado no nome do campo
 * @param {Array} structure - Estrutura do formulário
 * @param {string} fieldName - Nome do campo a ser atualizado
 * @param {Object} updates - Propriedades a serem atualizadas
 * @returns {Array} - Nova estrutura com as atualizações aplicadas
 */
export const updateFieldByName = (structure, fieldName, updates) => {
  const newStructure = [...structure];

  for (let rowIndex = 0; rowIndex < newStructure.length; rowIndex++) {
    const row = newStructure[rowIndex];

    for (let fieldIndex = 0; fieldIndex < row.length; fieldIndex++) {
      if (row[fieldIndex].name === fieldName) {
        newStructure[rowIndex][fieldIndex] = { ...newStructure[rowIndex][fieldIndex],
          ...updates
        };
        return newStructure;
      }
    }
  }

  return newStructure;
};
/**
 * Atualiza múltiplos campos em uma estrutura de formulário
 * @param {Array} structure - Estrutura do formulário
 * @param {Object} fieldUpdates - Objeto com nome do campo e suas atualizações
 * @returns {Array} - Nova estrutura com as atualizações aplicadas
 */

export const updateMultipleFieldsByName = (structure, fieldUpdates) => {
  let newStructure = [...structure];
  Object.entries(fieldUpdates).forEach(([fieldName, updates]) => {
    newStructure = updateFieldByName(newStructure, fieldName, updates);
  });
  return newStructure;
};
/**
 * Encontra um campo na estrutura do formulário pelo nome
 * @param {Array} structure - Estrutura do formulário
 * @param {string} fieldName - Nome do campo a ser encontrado
 * @returns {Object|null} - Campo encontrado ou null
 */

export const findFieldByName = (structure, fieldName) => {
  for (let rowIndex = 0; rowIndex < structure.length; rowIndex++) {
    const row = structure[rowIndex];

    for (let fieldIndex = 0; fieldIndex < row.length; fieldIndex++) {
      if (row[fieldIndex].name === fieldName) {
        return {
          field: row[fieldIndex],
          rowIndex,
          fieldIndex
        };
      }
    }
  }

  return null;
};